import Button from "@/common/elements/Button";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "@/components/InmateDetails/styles";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import API_ENDPOINTS from "@/util/api";
import {
  getOptionsFromRefList,
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { Form, Popconfirm } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

const PersonalMiscNumbersInfo = () => {
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [showMiscModal, setShowMiscModal] = useState(false);
  const [form] = Form.useForm();
  const [selectMisc, setSelectMisc] = useState(null);
  const [miscData, setMiscData] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const inputRef = useRef(null);
  const fullSearch = useSelector(state => state.fullSearch);
  useEffect(() => {
    let miscData = bookings?.bio?.[0]?.miscellaneousNumber;
    miscData = miscData?.map((misc) => {
      return {
        ...misc,
        miscNumber: getRefListNameByID("Misc_Number", misc?.miscNumberID),
        id: uuidv4(),
      };
    });

    setMiscData(miscData);
  }, [bookings]);

  useEffect(() => {
    if (isNonEmptyVariable(selectMisc)) {
      form.setFieldsValue(selectMisc);
    } else {
      form.resetFields();
    }
  }, [selectMisc]);

  const openModal = () => {
    setShowMiscModal(() => true);
  };

  const closeModal = () => {
    setShowMiscModal(() => false);
    setSelectMisc(() => null);
    setShowEdit(() => false);
    form.resetFields();
  };

  const selectMiscDataFn = (value) => {
    setSelectMisc(() => value);
    setShowEdit(true);
  };

  const saveClick = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("SavedValues tamil:", values);
        let md = miscData || [];
        if (showEdit) {
          md = md?.map((m) => {
            if (m?.id === selectMisc?.id) {
              return {
                ...m,
                ...values,
              };
            }

            return m;
          });
        } else {
          md.push(values);
        }

        dispatch(
          setBookings({
            bio: [
              {
                ...bookings?.bio?.[0],
                miscellaneousNumber: md,
              },
            ],
          })
        );

        closeModal();
      })
      .catch((err) => {});
  };

  const addMisc = () => {
    setSelectMisc(() => null);
    setShowEdit(() => false);
    openModal();
  };

  const editMisc = () => {
    openModal();
  };

  const deleteDC = () => {
    const md = miscData?.filter((p) => p?.id !== selectMisc?.id);

    dispatch(
      setBookings({
        bio: [
          {
            ...bookings?.bio?.[0],
            miscellaneousNumber: md,
          },
        ],
      })
    );

    if (isNonEmptyVariable(selectMisc?.miscellaneousNumberID)) {
      const url =
        API_ENDPOINTS.miscellaneousNumber +
        "/id/" +
        selectMisc?.miscellaneousNumberID;
      dispatch(setDeleteAPis(url));
    }

    closeModal();
  };
  useEffect(() => {
    if (showEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [showEdit]);
  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <div></div>
          <StyledFlex gap="10px">
            {
              <Button
                htmlType="button"
                onClick={addMisc}
                disabled={
                  !bookingsFieldsEnabled ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.ADD,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Add Misc Numbers
              </Button>
            }
            {
              <Button
                htmlType="button"
                disabled={
                  !showEdit ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.VIEW,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
                onClick={editMisc}
              >
                Details
              </Button>
            }
            <Popconfirm
              title="Delete the Misc Numbers"
              description="Are you sure you want to delete this MISC number?"
              onConfirm={deleteDC}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                disabled={
                  !showEdit ||
                  !bookingsFieldsEnabled ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.DELETE,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Delete
              </Button>
            </Popconfirm>
          </StyledFlex>
        </TableHeader>
        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        ) && (
          <Table
            headers={[
              { key: "miscNumber", text: "Description" },
              { key: "number", text: "Number" },
            ]}
            data={miscData}
            onRowClick={selectMiscDataFn}
            onRowDoubleClick={(value) => {
              selectMiscDataFn(value);
              editMisc();
            }}
            selected={selectMisc === null}
          />
        )}
      </InmateDetailsTableContainer>

      {showMiscModal && (
        <Modal
          header="Misc Numbers"
          show={showMiscModal}
          onHide={closeModal}
          footerActions={[
            {
              key: "save",
              text: "Save",
              onClick: saveClick,
              disabled: !bookingsFieldsEnabled || isDisabled,
            },
          ]}
          footerCloseAction={() => setShowEdit(false)}
          footerCloseActionText="Cancel"
        >
          <Form form={form} disabled={!bookingsFieldsEnabled}>
            <StyledGridRow gutter={16}>
              <StyledGridCol span={16}>
                <FormItem
                  name="miscNumberID"
                  label="Type"
                  required={!fullSearch}
                  rules={
                    !fullSearch
                    ? [
                      {
                        required: true,
                        message: "You must enter a type of number",
                      },
                    ]: []
                  }
                >
                  <Select
                    options={getOptionsFromRefList(
                      "Misc_Number",
                      false,
                      false,
                      true
                    )}
                    placeholder="Type"
                    showSearch={true}
                    variant="outlined"
                    disabled={!bookingsFieldsEnabled}
                  />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol span={8}>
                <FormItem
                  name="number"
                  label="Number"
                  required={!fullSearch}
                  rules={
                    !fullSearch
                    ?[
                      {
                        required: true,
                        message: "You must enter a number!",
                      },
                    ] : []
                  }
                >
                  <TextField />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </Modal>
      )}
    </>
  );
};
export default PersonalMiscNumbersInfo;
